import { useEffect, useState } from 'react';
import styles from './expandable-audience-line.module.scss';

const AUDIENCE_COLLAPSED_ITEM_COUNT = 6;

type ExpandableAudienceLineProps = {
  label: string;
  items: string[];
};

const formatAudienceValue = (items: string[], isExpanded: boolean) => {
  if (!items.length) return '—';

  const visibleItems =
    isExpanded || items.length <= AUDIENCE_COLLAPSED_ITEM_COUNT
      ? items
      : items.slice(0, AUDIENCE_COLLAPSED_ITEM_COUNT);

  const suffix =
    !isExpanded && items.length > AUDIENCE_COLLAPSED_ITEM_COUNT ? '...' : '.';

  return `${visibleItems.join('; ')}${suffix}`;
};

export const ExpandableAudienceLine = ({
  label,
  items,
}: ExpandableAudienceLineProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const canToggle = items.length > AUDIENCE_COLLAPSED_ITEM_COUNT;
  const itemsKey = items.join(';');

  useEffect(() => {
    setIsExpanded(false);
  }, [itemsKey]);

  return (
    <p className={styles.line}>
      <span className={styles.label}>{label}: </span>
      <span className={styles.value}>
        {formatAudienceValue(items, isExpanded)}
      </span>
      {canToggle && (
        <>
          {' '}
          <button
            type="button"
            className={styles.expandButton}
            onClick={() => setIsExpanded(current => !current)}
          >
            {isExpanded ? 'ver menos' : 'ver mais'}
          </button>
        </>
      )}
    </p>
  );
};
